export const TEAM_TYPES = [
    {
        key: 'unverified',
        label: 'Unverified',
        subtitle: 'Inactive, no matching',
        iconName: 'team-unverified',
        canSwitchTo: ['verified', 'premium', 'outbound'],
    },
    {
        key: 'verified',
        label: 'Verified',
        subtitle: 'Active, reverts on date',
        iconName: 'team-verified',
        canSwitchTo: ['unverified', 'premium', 'outbound'],
    },
    {
        key: 'premium',
        label: 'Premium',
        subtitle: 'Verified, date ignored',
        iconName: 'team-premium',
        canSwitchTo: [],
    },
    {
        key: 'outbound',
        label: 'Outbound',
        subtitle: 'Verified, reverts on date',
        iconName: 'team-outbound',
        canSwitchTo: ['unverified', 'verified', 'premium'],
    },
]

export const getTeamType = ({ verified, premium, outbound_enabled }) => {
    if (outbound_enabled) return 'outbound'
    if (premium)          return 'premium'
    if (verified)         return 'verified'
    return 'unverified'
}

// types each type may switch TO
export const canSwitchTeamType = (current, target) => {
    if (current === target) return true
    const currentType = TEAM_TYPES.find(t => t.key === current)
    return !!currentType?.canSwitchTo.includes(target)
}

// Verified and outbound teams revert to unverified on a date; the others ignore it.
export const usesRevertDate = (teamType) => teamType === 'verified' || teamType === 'outbound'
